import { useNavigate } from "react-router-dom";
import "./404.scss";

export default function Error404() {
  const navigate = useNavigate();
  return (
    <div className="error-404">
      <div className="image-404"></div>
      {window.screen.width > 1200 && (
        <div className="button">
          <button onClick={() => navigate("/")}>Върни се обратно</button>
        </div>
      )}
    </div>
  );
}
